// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"63d5d6a410c897c9a484","404":"146cc097c9d1c5b7e0f4","406":"fddc54f210452234f671"}[chunkId] + ".css";
};